/**
 * Sandbox-feature-local time formatting helpers. The codebase has several
 * "relative ago" implementations scattered through inbox / scheduled-jobs /
 * etc.; this one is shared across the sandbox surface (overview cards,
 * template detail, instances tab) so tweaks here don't ripple into
 * unrelated areas.
 *
 * Handles both past timestamps ("3m ago") and future timestamps ("in 3m").
 */
export function formatRelative(value?: string | null): string {
  if (!value) return 'Unknown';
  const deltaMs = Date.now() - new Date(value).getTime();
  if (!Number.isFinite(deltaMs)) return 'Unknown';
  const future = deltaMs < 0;
  const s = Math.floor(Math.abs(deltaMs) / 1000);
  if (s < 60) return future ? 'in a few seconds' : 'just now';
  const m = Math.floor(s / 60);
  if (m < 60) return future ? `in ${m}m` : `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return future ? `in ${h}h` : `${h}h ago`;
  const d = Math.floor(h / 24);
  return future ? `in ${d}d` : `${d}d ago`;
}

export function formatAbsolute(value?: string | null): string {
  if (!value) return '—';
  const d = new Date(value);
  if (!Number.isFinite(d.getTime())) return '—';
  return d.toLocaleString();
}
